
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/my-account/general",
      function () {
        return require("private-next-pages/settings/my-account/general.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/my-account/general"])
      });
    }
  